module.exports = __webpack_public_path__ + "static/02-8ff810f3cea12534a673fec80aa657f1.jpg";